module.exports = __webpack_public_path__ + "img/services-1.a50b1f1a.jpg";